import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/ri_search-line.png'


const _hoisted_1 = { class: "noResult" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "nrIcon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "nrTitle" }, "검색 결과가 없습니다.", -1)
const _hoisted_4 = { class: "nrContent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, _toDisplayString($setup.props.content ? $setup.props.content : "검색어를 잘못 기입했거나 아직 검색결과가 없을 수 있습니다."), 1)
  ]))
}